<template>
  <popup
    :opened="isDisplayExpirationSessionPopup"
    @close="close"
  >
    <div class="my-5 xl:my-15">
      <h3 class="mb-5 md:mb-10 2xl:mb-15">
        Votre session va expirer
      </h3>

      <div class="mb-10">
        <p class="text-indigo-600 text-lg text-center">
          Vos données n'ont pas été sauvegardées depuis longtemps.
        </p>
        <p class="text-indigo-600 text-lg text-center">
          Pensez à les sauvegarder pour éviter toute perte d'information
        </p>
      </div>

      <div class="flex justify-center bg-pink">
        <action-button
          class="mr-4"
          border-color="border-transparent"
          text-color="text-white"
          bg-color="bg-pink-600"
          bg-color-square="bg-pink-600"
          type-shadow="shadow-pink"
          libelle="OK"
          @clickAction="resetSessionTimer()"
        />
      </div>
    </div>
  </popup>
</template>

<script>
import { mapActions } from 'vuex';

import Popup from './../Popup.vue';
import Icon from './../Icon.vue';
import ActionButton from './../ActionButton.vue';

export default {
  props:{
    isDisplayExpirationSessionPopup:{
      type:Boolean,
      required:false,
      default:false,
    }
  },

  components:{
    Popup,
    Icon,
    ActionButton
  },

  methods:{
    ...mapActions({
      reloadSessionTime: 'auth/reloadSessionTime',
    }),

    close(){
      this.$emit('close');
    },

    async resetSessionTimer(){
      await this.reloadSessionTime().then(() => {
        this.close();
      });
    }
  }
};
</script>
